import type { qx_ePrivilege_enum } from '@/graphql/types';

// Hardcoded string-literal aliases for the two AI privileges. They live in
// the database (qx.ePrivilege) but client codegen against the GraphQL schema
// hasn't picked them up yet, so qx_ePrivilege_enum.AIAssistant / .AIBilling
// don't compile. Once codegen runs against a Hasura schema that includes the
// new ePrivilege rows, callers can switch back to qx_ePrivilege_enum.* and
// this module can be removed.
export const AI_ASSISTANT_PRIVILEGE = 'AIAssistant' as qx_ePrivilege_enum;
export const AI_BILLING_PRIVILEGE = 'AIBilling' as qx_ePrivilege_enum;
